import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Link } from '@codex/basics';
import { CustomIcon } from '../../../../Icon';
import { hasNav } from '../../../helpers';

const MenuItemLink = styled(Link)`
  position: relative;
  white-space: nowrap;
  display: block;
  font-size: 13px;
  padding: 6px 35px 6px 20px;
  color: ${({ theme }) => theme.colors.header.nav.link.text};
  min-width: 180px;

  ${props => props.showSubmenu && css`
    font-weight: 600;
    text-decoration: none;
    background-color: ${props.theme.colors.message.hover};
    color: ${props.theme.colors.link.default};
  `}

  &:hover {
    text-decoration: none;
  }
`;

const MenuItemIcon = styled(CustomIcon)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 5px;
  color: ${({ theme }) => theme.colors.header.nav.arrow};
  height: ${({ theme }) => (theme.name === 'brightworld' ? 'auto' : '28px')};
  width: ${({ theme }) => (theme.name === 'brightworld' ? 'auto' : '28px')};
  right: ${({ theme }) => (theme.name === 'brightworld' ? '10px' : '5px')};
`;

const Item = (props) => {
  const { menuItem, showSubmenu } = props;
  return (
    <MenuItemLink href={menuItem.link} showSubmenu={showSubmenu}>
      {menuItem.label}
      {hasNav(menuItem) && (
        <MenuItemIcon icon="ChevronRight" iconCDNDesktop="https://currys-ssl.cdn.dixons.com/css/themes/dory/icons/ArrowRightPurpleBrightworld.svg" size="large" />
      )}
    </MenuItemLink>
  );
};

Item.propTypes = {
  showSubmenu: PropTypes.bool.isRequired,
  menuItem: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string
  }).isRequired
};

export default Item;
